import React, { useEffect, useState } from "react";
import { Box, Typography, Modal, Button } from "@mui/material";
import Footer from "./Footer";
import Banner from "./Banner";
import BrandsSwiper from "./BrandsSwiper";
import Navbar from "./Navbar";
import Fitur from "./Fitur";
import Kategori from "./Kategori";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProdukNewArrivalLimit from "./ProdukSwipeCard"; // Import Komponen ProdukSwipeCard
import { useSearchParams } from "react-router-dom";
import apiClient from "../components/apiClient";
import { X } from "lucide-react";
import Popup from "../assets/popup.png";
import Breadcrumbs from "./Breadcrumbs";
import BlogSwiper from "./BlogSwiper";
import { location, useLocation } from "react-router-dom";
import zIndex from "@mui/material/styles/zIndex";

const Home = () => {
  const [promoList, setPromoList] = useState([]);
  const [currentPromoIndex, setCurrentPromoIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const fetchPromo = async () => {
      try {
        const response = await apiClient("/promo/show");
        if (Array.isArray(response.data) && response.data.length > 0) {
          setPromoList(response.data);
        }
      } catch (error) {
        console.error("Error fetching promo:", error);
      }
    };

    fetchPromo();
  }, []);

  useEffect(() => {
    // Wait 10 seconds before showing the popup
    const timer = setTimeout(() => {
      if (promoList.length > 0) {
        setShowPopup(true);
      }
    }, 10000);

    return () => clearTimeout(timer);
  }, [promoList]);

  useEffect(() => {
    if (!showPopup || promoList.length === 0) return;

    const interval = setInterval(() => {
      setCurrentPromoIndex((prevIndex) =>
        prevIndex === promoList.length - 1 ? 0 : prevIndex + 1,
      );
    }, 10000); // Change promo every 10 seconds

    return () => clearInterval(interval);
  }, [showPopup, promoList]);

  const promo = promoList[currentPromoIndex];

  // if (!promo) return null; // Hide popup only if promo is not available

  return (
    <div className="flex flex-col min-h-screen pt-[80px]">
    {/* <div className="flex flex-col min-h-screen pt-[90px]"> */}
      <main className="flex-grow px-4 py-8">
        <Navbar />
        <Banner />
        <Box sx={{ padding: "40px", marginBottom: "20px" }}>
          <Kategori />
        </Box>
        <Box
          sx={{ padding: "100px", marginTop: "100px", marginBottom: "10px" }}
        >
          <ProdukNewArrivalLimit />
        </Box>
        <Box sx={{ marginBottom: "100px" }}>
          <BrandsSwiper />
        </Box>
        <Box sx={{ marginBottom: "100px" }}>
          <BlogSwiper />
        </Box>
        <Box
          sx={{
            padding: "60px",
            marginTop: "0px",
            marginBottom: "0px",
            width: "100%",
            backgroundColor: "#FFFFFF",
          }}
        >
          <Fitur />
        </Box>

        {/* Toast Notifications */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          closeOnClick
          pauseOnHover
          draggable
          style={{ zIndex: 1500 }}
        />
      </main>
      <Footer />

      {/* Popup Modal (Only shown when showPopup is true) */}
      {showPopup && promo && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
          style={{ zIndex: "3000" }}
        >
          <div className="mt-20 md:mt-0 bg-white w-[90%] max-w-[827px] h-auto md:h-[416px] rounded-lg shadow-2xl relative flex flex-col md:flex-row overflow-hidden">
            {/* Left Side - Image */}
            <div className="w-full md:w-13/30">
              {promo.image && (
                <img
                  src={promo.image}
                  alt={promo.nama_promo || "Promo"}
                  className="w-full h-[400px] md:h-full object-cover"
                />
              )}
            </div>

            {/* Right Side - Content */}
            <div className="flex-1 p-4 md:p-6 flex flex-col justify-center relative">
              {/* Close Button */}
              <button
                onClick={() => setShowPopup(false)}
                className="absolute top-[-25rem] right-2 md:top-1 md:right-4 text-gray-500 hover:text-black transition"
              >
                <X size={24} />
              </button>

              {/* Title */}
              <h2 className="text-lg md:text-2xl font-bold text-gray-800 mb-2 text-center">
                {promo.nama_promo || "Promo Menarik"}
              </h2>

              {/* Description */}
              <p className="text-sm md:text-base text-gray-600 text-center mb-4 px-2 whitespace-pre-line">
                {promo.detail || ""}
              </p>

              {/* CTA Button */}
              {promo.url && (
                <div className="flex justify-center">
                  <a
                    href={promo.url}
                    rel="noopener noreferrer"
                    className="bg-red-600 hover:bg-red-700 text-white text-sm md:text-base px-5 py-2 rounded-full transition duration-300"
                  >
                    Read More
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
